import { Flex } from "../cores";

const IconAsterisk = () => {
  return (
    <Flex
      sx={{
        width: "30px",
        height: "30px",
        padding: 10,
        alignItems: "center",
        justifyContent: "center",
        fontSize: "md",
        minWidth: "fit-content",
      }}
    >
      &#42;
    </Flex>
  );
};

export default IconAsterisk;
